import React from 'react';
import { MultiCombo } from 'fw/forms';
import * as API from 'modules/app/API'

class BusinessOwnershipMultiCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        API.Certification.get('/query/getBusinessOwnershipTypes', {},
            {
                success: (r) => {
                    this._isMounted && this.setState({
                        items: r.data.items.map((item) => { return { label: item.businessOwnershipName, value: item.businessOwnershipId } })
                    });
                }
            },
            { block: false });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <MultiCombo 
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Select..."}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default BusinessOwnershipMultiCombo;

// Mark this as a form component
BusinessOwnershipMultiCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/businessOwnershipMultiCombo/BusinessOwnershipMultiCombo.js